// extracted by mini-css-extract-plugin
export default {"container":"Loader_container--__m","animation":"Loader_animation--oGr","scaling":"Loader_scaling--BoO","spin":"Loader_spin--vSM"};